import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Card from '../Card';
import Heading from './Heading';
import Item from './Item';

function Menu(props) {
  return /*#__PURE__*/React.createElement(Card, _extends({
    paddingVertical: 0.5,
    minWidth: 12,
    overflow: "auto",
    outline: 0
  }, props));
}

Menu.Heading = Heading;
Menu.Item = Item;
export default Menu;